module.exports = __webpack_public_path__ + "img/thumbnail_GreaterRhea_m_normal.ee82372c.png";